<template>
  <div>
    <v-row id="filter-col-padding" no-gutters>
      <v-col>
        <v-text-field
          hide-details
          filled
          dense
          v-model="cpfMasked"
          v-mask="['###.###.###-##']"
          :placeholder="$t('analysisPerServiceDeliveredFilter.citizensCPF')"
          prepend-inner-icon="mdi-card-account-details-outline"
        ></v-text-field>
      </v-col>

      <v-col cols='12'>
        <div class="textLabel colorDark" style="margin-top: 12px;">
          {{$t('analysisPerServiceDeliveredFilter.searchByDeliveredService')}}
        </div>
        <v-text-field
          hide-details
          filled
          dense
          v-model='service'
          :placeholder="$t('analysisPerServiceDeliveredFilter.service')"
        ></v-text-field>
      </v-col>

      <v-col cols='12'>
        <v-text-field
          hide-details
          filled
          dense
          v-model='returnCode'
          :placeholder="$t('analysisPerServiceDeliveredFilter.returnCode')"
          class="input-code-return"
        ></v-text-field>
      </v-col>

    </v-row>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
// import { mapGetters } from 'vuex'
import { mask } from 'vue-the-mask'

export default {
  directives: { mask },
  computed: {
    ...mapFields('analysisPerServiceDeliveredFilter', ['citizensCPF', 'service', 'returnCode']),
    ...mapFields('reports', ['dateInterval'])
  },
  watch: {
    cpfMasked (nV) {
      this.citizensCPF = nV.replace('.', '').replace('-', '').replace('/', '').replace('.', '')
    }
  },
  data () {
    return {
      channels: ['webclient', 'whatsapp', 'teams', 'facebook', 'instagram'],
      evaluation: [1, 0.8, 0.6, 0.4, 0.2, 0],
      intents: [],
      cpfMasked: undefined
    }
  },
  methods: {
    async getIntents () {
      const result = await this.$axios.get(`${process.env.VUE_APP_BACKEND_BASE_URL}/snapshots`, {
        params: {
          workspace: this.active.id,
          status: 'published',
          fields: 'data.intents.intent'
        }
      })
      this.intents = result.data.data[0]._source.data.intents.map((obj) => obj.intent)
    }
  }
}
</script>

<style scoped>
.v-input__prepend-inner {
  margin-right: auto;
  padding-right: 8px;
}
#filter-col-padding .col {
  padding: 8px;
}

.v-input {
  padding: 15px 0px !important;
}

.input-code-return {
  padding-bottom: 2.5rem !important;
  border-bottom: 2px solid #E1E1E1;
}
</style>
